import { useNavigate, useLocation } from "react-router";
import { Button } from "@heroui/react";
import { ArrowRight } from "lucide-react";
import { ShipmentDetailsStep } from "./steps/shipment-details-step";
import { CreateShell } from "./create-order-layout";
import { useCreateOrder } from "./create-order-context";
import { DraftSavedIndicator } from "./draft-saved-indicator";
import type { OrderDraft } from "./types";
import { useTranslation } from "react-i18next";

const FORM_ID = "create-shipment-details-form";

export default function CreateShipmentDetailsScreen() {
  const { t } = useTranslation("app");
  const navigate = useNavigate();
  const { hash } = useLocation();
  const editParty =
    hash === "#sender"
      ? "sender"
      : hash === "#recipient"
        ? "recipient"
        : undefined;
  const { data, update } = useCreateOrder();

  const handleNext = (stepData: Partial<OrderDraft>) => {
    update(stepData);
    void navigate("/new-shipment/pricing");
  };

  return (
    <CreateShell
      step={1}
      title={t("createShipment.detailsTitle")}
      italic={t("createShipment.detailsItalic")}
      lede={t("createShipment.detailsLede")}
      footer={
        <>
          <div className="hidden md:block">
            <DraftSavedIndicator />
          </div>
          <div className="flex gap-2 md:gap-3 w-full md:w-auto">
            <Button
              variant="light"
              className="hidden md:inline-flex"
              onPress={() => void navigate("/dashboard")}
            >
              {t("createShipment.exit")}
            </Button>
            <Button
              type="submit"
              form={FORM_ID}
              color="primary"
              fullWidth
              className="md:w-auto"
              endContent={<ArrowRight className="h-4 w-4" />}
            >
              {t("createShipment.continueToPricing")}
            </Button>
          </div>
        </>
      }
    >
      <ShipmentDetailsStep
        data={data}
        editParty={editParty}
        onNext={handleNext}
        formId={FORM_ID}
        hideNavigation
      />
    </CreateShell>
  );
}
